import PropTypes from 'prop-types'
import React from 'react'

import BuyButton from '../buy/dumb/BuyButton'
import BuyModal from '../buy/dumb/BuyModal'

const BackToProductModal = ({ koFn, okFn }) => (
  <BuyModal>
    <div className="the-modal modal show">
      <div className="error__popup" style={{ width: '500px' }}>
        <div className="error__popup__close" onClick={koFn}>
          <i className="icon-close" />
        </div>
        <p style={{ margin: '40px', textAlign: 'center' }}>
          Sei sicuro di voler tornare alla pagina prodotto?
        </p>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <BuyButton
            classes="btn btn-secondary"
            label="Torna all'auto"
            update={okFn}
          />
          <BuyButton
            classes="btn btn-primary ml-10"
            label="Resta qui"
            update={koFn}
          />
        </div>
      </div>
    </div>
  </BuyModal>
)

BackToProductModal.defaultProps = {
  koFn: () => {},
  okFn: () => {},
}

BackToProductModal.propTypes = {
  koFn: PropTypes.func,
  okFn: PropTypes.func,
}

export default BackToProductModal
